import {DropZoneOrder} from "./OrderToRegroupWrapper";

export class DropZone {
    constructor() {
        this.items = [];
    }

    title: string;

    /**
     * True when the applied arrangement put the pile's naked leg(s) in this zone (planner shape
     * 'naked'). Hand-made zones never set it. Drives the exclamation marker + the warning that
     * this order must be executed before the others.
     */
    naked = false;

    items: DropZoneOrder[];

    limitPrice: number;

    add(order: DropZoneOrder) {
        this.items.push(order);
    }
}